import React from 'react'

import { IconError, IconInfo } from 'components/ui/icons';

import { bundleProcessingRunning, runningMessage, bundleProcessingFailed, errorMessage, bundleName } from 'domains/org/getty/utils/bundles'

import { Bundle } from 'generated/mos/org/getty/publish'

import { space } from 'helpers/style'

import styled from 'styled'

const BundleItem = ({bundle}: {bundle: Bundle.Entity}) => {
  const Li = styled.li`
    &:before {
      content: "•";
      margin-right: ${space(2)};
    }
    display: flex;
  `

  let message = <>{bundleName(bundle)} bundle</>;
  if (bundleProcessingFailed(bundle)) {
    message = <>{errorMessage(bundle)}&nbsp;<IconError size="base" color="error" /></>;
  } else if (bundleProcessingRunning(bundle)) {
    message = <>{runningMessage(bundle)}&nbsp;<IconInfo size="base" color="info" /></>;
  }

  return <Li>{message}</Li>
}

export const BundleList = ({bundles}: {bundles: ReadonlyArray<Bundle.Entity>}) => {
  const Ul = styled.ul`
    display: block;
    margin-top: ${space(4)};
    padding-left: 0;
  `

  return <Ul>{
    bundles
    .filter(({ bundleType }) => bundleType !== 'BUNDLE_TYPE_UNSPECIFIED')
    .map((bundle) => <BundleItem key={bundle.ref!.id} bundle={bundle} />)
  }</Ul>;
};
